import React from "react";
import "./style.scss";
import ReactApexChart from "react-apexcharts";
import Select from "react-select";
import {useSelector} from "react-redux";

function PushLeads({codeList}) {
  const options = [
    {value: "monthly", label: "Monthly"},
    {value: "yearly", label: "Yearly"},
    {value: "quarterly", label: "Quarterly"},
  ];

  const dateOptions = [{value: "d", label: "Dec 2023"}];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "110px",
      height: "20px",
      boxSizing: "content-box",
      fontSize: "12px",
      color: "#fff",
      fontWeight: "500",
      fontFamily: "Space Grotesk",
      borderRadius: "8px",
      float: "right",
      background: "#111512",
      dropdownIndicator: (provided) => ({
        ...provided,
        color: "#35d269",
        width: "20px",
      }),
    }),
  };

  return (
    <div className="pushleads">
      <div className="pushleads_wrapper">
        <div className="chart_wrapper">
          <div className="chart_header">
            <p className="chart_title">Clicks Statistic</p>
            <div>
              {/* <Select
                options={options}
                value={options[0]}
                styles={customStyles}
                components={{
                  IndicatorSeparator: () => null,
                }}
                menuPortalTarget={document.body}
                menuPlacement="bottom"
                menuPosition="fixed"
                menuStyle={{ width: "120px" }}
              /> */}

              {/* <Select
                options={dateOptions}
                value={dateOptions[0]}
                styles={customStyles}
                components={{
                  IndicatorSeparator: () => null,
                }}
                menuPortalTarget={document.body}
                menuPlacement="bottom"
                menuPosition="fixed"
                menuStyle={{ width: "120px" }}
              /> */}
            </div>
          </div>
          <Chart codeList={codeList} />
        </div>
      </div>
    </div>
  );
}

export default PushLeads;

function Chart({codeList}) {
  const chartData = codeList || [];
  const created_date = codeList?.map((item) => item.created_day);
  const clicks = codeList?.map((item) => item.clicks);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);
  const series = [
    {
      name: "clicks",
      data: clicks,
    },
  ];

  const options = {
    chart: {
      type: "area",
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      type: "datetime",
      categories: created_date,
      labels: {
        style: {
          colors: "#fff",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "#fff",
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    // stroke: {
    //   curve: "smooth",
    //   colors: ["#35d269"],
    // },
    // fill: {
    //   colors: ["#35d269"],
    // },
    stroke: {
      curve: "smooth",
      colors: [selectedBrand?.brand === "equity_edge" ? "#35d269" : selectedBrand?.brand === "crypto_edge" ? "#FCD535" : "#35d269"],
    },
    fill: {
      colors: [selectedBrand?.brand === "equity_edge" ? "#35d269" : selectedBrand?.brand === "crypto_edge" ? "#FCD535" : "#35d269"],
    },

    grid: {
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
  };

  return (
    <div className="area-chart">
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height="100%"
      />
    </div>
  );
}
